import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const twMerge = extendTailwindMerge<'border-ui'>({
  extend: {
    classGroups: {
      'border-ui': ['border-ui'],
    },
    conflictingClassGroups: {},
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
